import type Point from '@arcgis/core/geometry/Point';
import type { ArcgisMap } from '@arcgis/map-components/components/arcgis-map';

export interface PopoverPosition {
  left: string;
  top: string;
}

export function CalculatePopoverPosition(
  map: ArcgisMap,
  geometry: Point,
): PopoverPosition | undefined {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- The map may not be initialized yet.
  if (!map) {
    return;
  }

  const _screenPoint = map.toScreen(geometry);
  if (!_screenPoint) {
    return;
  }

  const _popoverHeight = 144;
  const _popoverWidth = 384;
  const _gap = 10;
  const _topThreshold = _popoverHeight + _gap;
  const _leftThreshold = _popoverWidth + _gap;
  const _rightThreshold = map.clientWidth - _popoverWidth - _gap;
  let x = _screenPoint.x || 0;
  let y = _screenPoint.y || 0;

  // The popover is above the graphic unless it is too close to the threshold.
  if (y >= _topThreshold) {
    y -= _popoverHeight + _gap;
  } else {
    y += _gap;
  }

  // The popover is centered on the graphic unless it is too close to either the left or right thresholds.
  if (x < _leftThreshold) {
    // Popover is to the right of the graphic.
    x = (_screenPoint.x || 0) + _gap;
  } else if (x >= _rightThreshold) {
    // Popover is to the left of the graphic.
    x = (_screenPoint.x || 0) - _popoverWidth - _gap;
  } else {
    // Popover is centered on the graphic.
    x -= _popoverWidth / 2;
  }

  return {
    left: `${x}px`,
    top: `${y}px`,
  };
}
